export default __webpack_public_path__ + "static/media/330_dummy2016-klempner01-mobile-de.9592cb03.png";